import React, {useEffect} from 'react';
import {Select} from 'antd';
import {showMessages, messageType} from '../helpers/message';

import {useGetDeploymentsOnlyAvailableQuery} from '../store/api/deploymentsApi';
import {BaseError} from '../types/apiTypes';
import {DeploymentSelectProps} from '../types/bookingTypes';

const DeploymentSelect = ({
    startedAt,
    endedAt,
    onChange,
    deploymentID,
    disabled = false,
    deployableDescription,
    locationDescription,
}: DeploymentSelectProps) => {
    const {
        data: deploymentsData = [],
        isFetching,
        error,
    } = useGetDeploymentsOnlyAvailableQuery(
        {
            startedAt: startedAt,
            endedAt: endedAt
        },
        {
            skip: !startedAt || startedAt === endedAt, // Only fetch if there's a valid start and end time.
            // I don't think the skip check is necessary.. Start should never be falsy and won't be the same as ended_at.
        }
    );

    useEffect(() => {
        if (error) {
            showMessages((error as BaseError).data?.message, messageType.error);
        }
    }, [error,deploymentsData]);

    return (
        <Select
            placeholder="Select a car"
            loading={isFetching}
            onChange={(value) => onChange(value)}
            defaultValue={deploymentID}
            disabled={disabled || isFetching}
            dropdownMatchSelectWidth={600}
        >
            {deploymentsData?.map((deployment) => (
                <Select.Option
                    key={deployment.id}
                    value={deployment.id}
                >
                    {deployment.deployable_description} @ {deployment.location_description}
                </Select.Option>
            ))}
            {deploymentID && (
                <Select.Option key={deploymentID} value={deploymentID}>
                    {deployableDescription} @ {locationDescription}
                </Select.Option>
            )}
        </Select>
    );
};

export default DeploymentSelect;
